import axios from "axios";
import { useEffect, useState } from "react";
import { LayoutHeader } from "../../components/layout-header";
import { TodayDate } from "../../components/today-date";
import { TodayWeather } from "../../components/today-weather";
import {
  PrecipitationType,
  Sky,
  Weather,
  WeatherAPIResult,
  Weekday,
} from "../../types";

const Home = () => {
  const [todayWeather, setTodayWeather] = useState<Weather>({
    curTemperature: 0,
    maxTemperature: 0,
    minTemperature: 0,
    sky: "맑음",
    precipitationType: null,
    precipitation: 0,
    precipitationPercentage: 0,
    windSpeed: 0,
  });

  let weatherAPIResult: Weather = {
    curTemperature: 0,
    maxTemperature: 0,
    minTemperature: 0,
    sky: "맑음",
    precipitationType: null,
    precipitation: 0,
    precipitationPercentage: 0,
    windSpeed: 0,
  };

  const getKoreaTime = () => {
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, "0");
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const yyyy = now.getFullYear();

    // const utcNow = now.getTime() + now.getTimezoneOffset() * 60 * 1000;
    // const koreaTimeDiff = 9 * 60 * 60 * 1000;
    // const koreaNow = new Date(utcNow + koreaTimeDiff);
    // console.log(koreaNow.toISOString().slice(0, 10));
    return {
      weekday: Weekday[now.getDay()],
      date: yyyy + " " + mm + " " + dd,
      hour: now.getHours(),
    };
  };

  const getSky = (sky: string): Sky => {
    if (sky === "1") return "맑음";
    else if (sky === "3") return "구름많음";
    return "흐림";
  };

  const getPrecipitationType = (
    precipitationType: string
  ): PrecipitationType => {
    if (precipitationType === "0") return null;
    else if (precipitationType === "1") return "비";
    else if (precipitationType === "2") return "비와 눈";
    else if (precipitationType === "3") return "눈";
    return "소나기";
  };

  const getBaseTime = (hour: number): string => {
    const numberHour = (hour - 2) / 3 + 2;
    const stringHour =
      numberHour % 10 === 0
        ? "0" + String(numberHour) + "00"
        : "0" + String(numberHour) + "00";
    console.log(`stringHour: ${stringHour}`);
    return "2000";
  };

  useEffect(() => {
    axios({
      method: "GET",
      params: {
        nx: 63,
        ny: 126,
        pageNo: 1,
        numOfRows: 400,
        dataType: "JSON",
        base_date: getKoreaTime().date.replace(/\s/g, ""),
        base_time: getBaseTime(getKoreaTime().hour),
      },
      url: `/api?serviceKey=${process.env.REACT_APP_WEATHER_API_KEY}`,
    }).then((res) => {
      const items: WeatherAPIResult[] =
        res.data.response.body.items.item.filter(
          (option: WeatherAPIResult) =>
            (option.baseDate === option.fcstDate &&
              Number(option.fcstTime) - Number(option.baseTime) === 100) ||
            option.category === "TMX" ||
            option.category === "TMN"
        );
      console.log(items);

      items.map((item) => {
        if (item.category === "TMP")
          weatherAPIResult.curTemperature = Number(item.fcstValue);
        else if (item.category === "SKY")
          weatherAPIResult.sky = getSky(item.fcstValue);
        else if (item.category === "PTY")
          weatherAPIResult.precipitationType = getPrecipitationType(
            item.fcstValue
          );
        else if (item.category === "PCP")
          weatherAPIResult.precipitation = Number(item.fcstValue) || null;
        else if (item.category === "TMX")
          weatherAPIResult.maxTemperature = Number(item.fcstValue);
        else if (item.category === "TMN")
          weatherAPIResult.minTemperature = Number(item.fcstValue);
        else if (item.category === "PDP")
          weatherAPIResult.precipitationPercentage = Number(item.fcstValue);
        else if (item.category === "WSD")
          weatherAPIResult.windSpeed = Number(item.fcstValue);
        return null;
      });

      setTodayWeather({
        curTemperature: weatherAPIResult.curTemperature,
        sky: weatherAPIResult.sky,
        precipitationType: weatherAPIResult.precipitationType,
        precipitation: weatherAPIResult.precipitation,
        maxTemperature: weatherAPIResult.maxTemperature,
        minTemperature: weatherAPIResult.minTemperature,
        precipitationPercentage: weatherAPIResult.precipitationPercentage,
        windSpeed: weatherAPIResult.windSpeed,
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LayoutHeader location="서울" todayWeather={todayWeather}>
      <TodayDate weekday={getKoreaTime().weekday} date={getKoreaTime().date} />
      <TodayWeather todayWeather={todayWeather}></TodayWeather>
    </LayoutHeader>
  );
};

export default Home;
